import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import type { MetricsStep } from '@/services/dynamicFlowsService';
import { formatNumber, formatPercent } from './format';

export function StepsTable({ steps }: { steps: MetricsStep[] }) {
  useLanguage();
  const maxEntries = Math.max(1, ...steps.map((step) => step.entries));

  return (
    <section className="flex min-w-0 flex-[2_1_520px] flex-col gap-3 rounded-2xl border border-[#D9E0EA] bg-white p-[18px]">
      <h2 className="text-[15px] font-bold text-[#111827]">{translateInterfaceText("Por etapa")}</h2>
      {steps.length === 0 ? (
        <p className="text-sm text-[#4B5563]">{translateInterfaceText("O fluxo ainda não tem etapas.")}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[520px] border-collapse text-[13px]">
            <thead>
              <tr className="text-left text-[#4B5563]">
                <th scope="col" className="border-b border-[#E5E7EB] px-2.5 py-2 font-semibold">
                  {translateInterfaceText("Etapa")}</th>
                <th scope="col" className="w-[34%] border-b border-[#E5E7EB] px-2.5 py-2 font-semibold">
                  {translateInterfaceText("Entradas")}</th>
                <th scope="col" className="border-b border-[#E5E7EB] px-2.5 py-2 text-right font-semibold">
                  {translateInterfaceText("Deram play")}</th>
                <th scope="col" className="border-b border-[#E5E7EB] px-2.5 py-2 text-right font-semibold">
                  {translateInterfaceText("Assistido em média")}</th>
              </tr>
            </thead>
            <tbody>
              {steps.map((step) => (
                <tr key={step.node_id} className="border-b border-[#F1F5F9] last:border-0">
                  <td className="px-2.5 py-2.5 font-semibold text-[#111827]">
                    {step.label}
                    {step.is_start && (
                      <span className="ml-1.5 text-[11px] font-bold text-[#0057FF]">{translateInterfaceText("INÍCIO")}</span>
                    )}
                  </td>
                  <td className="px-2.5 py-2.5">
                    <div className="flex items-center gap-2">
                      <span className="h-2 flex-1 rounded-full bg-[#EEF2F7]" aria-hidden="true">
                        <span
                          className="block h-2 rounded-full bg-[#0057FF]"
                          style={{ width: `${(step.entries / maxEntries) * 100}%` }}
                        />
                      </span>
                      <span className="w-14 text-right tabular-nums">{formatNumber(step.entries)}</span>
                    </div>
                  </td>
                  <td className="px-2.5 py-2.5 text-right tabular-nums">{formatPercent(step.play_rate)}</td>
                  <td className="px-2.5 py-2.5 text-right tabular-nums">{formatPercent(step.avg_watched)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
